import React from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { useSwipeable } from 'react-swipeable'
import { getQuizPage, nextPage, previousPage } from 'ducks/router'
import './SwipePage.scss'

// Slider
export const Slider = React.forwardRef(
  (
    {
      reversed = false, // css animation direction
      vertical = false, // swipe and css animation direction
      slideSpeed = 500, // css animation duration
      page = 0, // key property
      style = {},
      ...props
    },
    ref,
  ) => {
    const delay = parseInt(slideSpeed * 0.4)
    const transition = `opacity ease-out ${slideSpeed -
      delay}ms ${delay}ms, transform ease ${slideSpeed}ms`
    return (
      <TransitionGroup className={cx('Slider', { reversed, vertical })}>
        <CSSTransition
          key={page}
          timeout={slideSpeed}
          className="slide"
          classNames="slide"
        >
          <div
            ref={ref}
            style={{
              ...style,
              transition,
            }}
            {...props}
          />
        </CSSTransition>
      </TransitionGroup>
    )
  },
)

// Firefox image dragging workaround
const dragStart = ev => ev.preventDefault()

// swipeable page container with route change using react first router
export const SwipePage = ({
  reversed = false, // css animation direction
  vertical = false, // swipe and css animation direction
  slideSpeed = 500, // css animation duration
  swipeTrigger = 50, // swipe pixels limit to trigger page transition
  nextPage, // connected action creator
  previousPage, // connected action creator
  page = 0, // key property
  children,
}) => {
  const [transform, setTransform] = React.useState(null)
  const handlers = useSwipeable({
    onSwiping: ev => {
      const [dx, dy] = vertical ? [0, -ev.deltaY] : [-ev.deltaX, 0]
      setTransform(`translate(${dx}px, ${dy}px)`)
    },
    onSwiped: ev => {
      setTransform(null)
      const delta = vertical ? ev.deltaY : ev.deltaX
      if (delta < swipeTrigger) previousPage()
      if (delta > -swipeTrigger) nextPage()
    },
    preventDefaultTouchmoveEvent: true,
    trackTouch: true,
    trackMouse: true,
  })
  return (
    <Slider
      page={page}
      reversed={reversed}
      vertical={vertical}
      slideSpeed={transform ? 100 : slideSpeed}
      style={{ transform }}
      {...handlers}
      onDragStart={dragStart}
    >
      {children}
    </Slider>
  )
}

// Redux connection
export default connect(
  getQuizPage,
  { nextPage, previousPage },
)(SwipePage)
